angular.
module('moebiusProadapt')

    /**
     * show when in dev environment
     */
    .directive('activedEnvDev', function($rootScope) {
        return {
            restrict: 'E',
            transclude:true,
            template: '<span ng-if="activedCurrentEnvironmentMatch && showDebug"><ng-transclude></ng-transclude></span>',
            scope : {},
            controller: function ($scope, $element, $attrs, $rootScope) {
                $scope.showDebug = $rootScope.globalParams.showDebug;
                $scope.activedCurrentEnvironmentMatch = false;
                if ($rootScope && $rootScope.constants && $rootScope.constants.environment) {
                    $scope.activedCurrentEnvironmentMatch = ($rootScope.constants.environment === 'development' || $rootScope.constants.environment === 'local');
                }
            }
        };
    })

    /**
     * show when test environment
     */
    .directive('activedEnvTest', function() {
        return {
            restrict: 'E',
            transclude:true,
            scope : {},
            template: '<span ng-if="activedCurrentEnvironmentMatch"><ng-transclude></ng-transclude></span>',
            controller: function ($scope, $element, $attrs, $rootScope) {
                // -- test see production AND test
                $scope.activedCurrentEnvironmentMatch = false;
                if ($rootScope && $rootScope.constants && $rootScope.constants.environment) {
                    $scope.activedCurrentEnvironmentMatch = ($rootScope.constants.environment === 'development' || $rootScope.constants.environment === 'test');
                }
            }
        };
    })

    /**
     * show when prod environment
     */
    .directive('activedEnvProd', function() {
        return {
            restrict: 'E',
            transclude:true,
            scope : {},
            template: '<span ng-if="activedCurrentEnvironmentMatch"><ng-transclude></ng-transclude></span>',
            controller: function ($scope, $element, $attrs, $rootScope) {

                $scope.activedCurrentEnvironmentMatch = false;
                if ($rootScope && $rootScope.constants && $rootScope.constants.environment) {
                    $scope.activedCurrentEnvironmentMatch = ($rootScope.constants.environment === 'production' || $rootScope.constants.environment === 'test' || $rootScope.constants.environment === 'development');
                }
            }
        };
    })


    .directive('cmeloSticky', ['$window', function ($window) {
        return {
            restrict: 'A',
            link: function (scope, elem) {

                var wrapper = elem;
                console.log('*************** cmeloSticky' , elem);
                var nodename = elem.eq(0)[0].nodeName.toLowerCase();
                var el = elem;

                if (nodename === 'body') {
                    wrapper = angular.element($window);
                }

                function getScrolltop (el) {
                    if (nodename === 'body') {
                        return document.querySelector('html').scrollTop +
                            document.querySelector('body').scrollTop;
                    } else {
                        return el.eq(0)[0].scrollTop;
                    }
                }

                function getOffset(el) {
                    if (!el) { return Infinity; }
                    var res = !el.offsetParent ? el.offsetTop : el.offsetTop + el.offsetParent.offsetTop ;
                    return res ;
                }

                function getClosest(el, attribute) {
                    for (; el && el !== document &&
                           el.nodeType === 1; el = el.parentNode) {

                        if (el.hasAttribute(attribute)) { return el; }
                    }
                    return null;
                }

                wrapper.on('scroll', function () {

                    var stickers_all = document.querySelectorAll('[cmelo-sticky-top]');
                    var stickers = [];

                    angular.forEach(stickers_all, function (sticker) {
                        var parent = getClosest(sticker, 'cmelo-sticky');
                        if (parent === elem.eq(0)[0]) {
                            stickers.push(sticker);
                        }
                    });


                    angular.forEach(stickers, function (sticker, i) {

                        var top = parseInt(sticker.getAttribute('cmelo-sticky-top'));
                        if (isNaN(top)) { top = 0; }

                        var offset_top = getOffset(sticker);
                        var offset_next = getOffset(stickers[i+1]);
                        var height = sticker.offsetHeight;
                        var scroll_top = getScrolltop(el);


                        var diff = scroll_top - offset_top + top;
                        var next_diff = scroll_top + top + height - offset_next;
                        if (next_diff > 0) { diff -= next_diff; }

                        if (sticker.nodeName.toLowerCase() === 'thead') {
                            var parent_diff =  diff + height -
                                sticker.offsetParent.offsetHeight;
                            if (parent_diff > 0) {
                                diff -= parent_diff;
                            }
                        }


                        var sticker_el = angular.element(sticker);

                        if (diff > 0) {
                            sticker_el.addClass('cmelo-sticky-on');
                            sticker_el.css({
                                transform: 'translateY(' + diff + 'px)'
                            });
                        } else {
                            sticker_el.removeClass('cmelo-sticky-on');
                            sticker_el.css({
                                transform: 'translateY(0px)'
                            });
                        }

                    });

                });


            }
        };
    }])
;


// WEBPACK FOOTER //
// ./resources/assets/js/directives/actived.js